var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIncident = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 517.583 534.621"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-8.618)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 67"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 363",
  d: "M115.935 0h243.181a31.867 31.867 0 0131.867 31.867V497a15 15 0 01-15 15H23.618a15 15 0 01-15-15V107.329l71.3-31.307z",
  fill: "#eaf4ff"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66",
  fill: "#cde7fc"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 364",
  d: "M100.935 107.317H8.618L115.935 0v92.317a15 15 0 01-15 15z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 365",
  d: "M375.983 0H199.8v512h176.183a15 15 0 0015-15V15a15 15 0 00-15-15z"
}))), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 5",
  cx: 112.399,
  cy: 112.399,
  r: 112.399,
  transform: "rotate(-13.3 1482.616 -938.943)",
  fill: "#ffe478"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 366",
  d: "M390.983 287.2a112.526 112.526 0 00-112.4 112.4",
  fill: "#ffe478"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 68",
  fill: "#988fcc"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 367",
  d: "M88.808 191.029h221.986a15 15 0 000-30H88.808a15 15 0 000 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 368",
  d: "M310.794 221.029H88.808a15 15 0 000 30h221.986a15 15 0 100-30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 369",
  d: "M225.974 281.029H88.808a15 15 0 000 30h137.166a15 15 0 000-30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 370",
  d: "M225.974 341.029H88.808a15 15 0 000 30h137.166a15 15 0 000-30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 371",
  d: "M225.974 401.029H88.808a15 15 0 000 30h137.166a15 15 0 000-30z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 69",
  fill: "#6e61b7"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 372",
  d: "M225.974 401.029H199.8v30h26.173a15 15 0 000-30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 373",
  d: "M225.974 341.029H199.8v30h26.173a15 15 0 000-30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 374",
  d: "M225.974 281.029H199.8v30h26.173a15 15 0 000-30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 375",
  d: "M310.794 221.029H199.8v30h110.994a15 15 0 100-30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 376",
  d: "M310.794 161.029H199.8v30h110.994a15 15 0 000-30z"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 377",
  d: "M390.983 287.2V512a112.4 112.4 0 000-224.8z",
  fill: "#ffd43b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 378",
  d: "M405.984 369.6v-24.66a15 15 0 00-30 0v79.323a15 15 0 1030 0V369.6z",
  fill: "#ed6c7b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 379",
  d: "M405.985 344.941a15 15 0 00-15-15v109.323a15 15 0 0015-15v-79.323z",
  fill: "#d65b72"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6",
  cx: 13.5,
  cy: 13.5,
  r: 13.5,
  transform: "translate(378.618 458.31)",
  fill: "#d65b72"
}))));
export default SvgIncident;